import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { HiLockClosed, HiArrowLeft } from 'react-icons/hi';

const API =  process.env.REACT_APP_API_URL;

const HERO_SLIDES = [
  '/images/wavvy.jpeg',
  '/images/wavvyone.jpeg',
  '/images/wavvytwo.jpeg',
];

export default function PasswordAccess() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  // Slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % HERO_SLIDES.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/api/site-lock/verify-password`, {
        password: password.trim(),
      });
      // Backend returns { token: "site-access-token" } on success
      const { token } = res.data;
      if (token) {
        sessionStorage.setItem('siteAccessToken', token);
        navigate('/');
      } else {
        setError('Incorrect password. Please try again.');
      }
    } catch (err) {
      setError('Incorrect password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-black">
      {/* Slideshow Background */}
      {HERO_SLIDES.map((slide, index) => (
        <div
          key={index}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-[2000ms] ease-in-out"
          style={{
            backgroundImage: `url('${slide}')`,
            opacity: index === currentSlide ? 1 : 0,
          }}
        />
      ))}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

      {/* Password form */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-4">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <HiLockClosed className="text-5xl text-white mx-auto mb-4" />
            <h1 className="text-3xl font-bold text-white">Enter Password</h1>
            <p className="text-white/60 mt-2">Access the store using the password.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="password"
              placeholder="Password"
              className="w-full bg-white/10 border border-white/30 rounded-xl px-4 py-3 text-white text-sm placeholder-white/50 focus:outline-none focus:border-white/60"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
            {error && <p className="text-red-400 text-xs">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black py-3 rounded-xl font-semibold text-sm hover:bg-gray-200 transition disabled:opacity-50"
            >
              {loading ? 'Unlocking…' : 'Unlock'}
            </button>
          </form>

          <div className="text-center space-y-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-white/50 hover:text-white transition"
            >
              <HiArrowLeft size={16} /> Back to store
            </Link>
            <p className="text-white/50 text-sm">
              Are you the store owner?{' '}
              <Link to="/owner-login" className="text-white underline hover:no-underline">
                Log in here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}